import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogProviderService } from '@app/core/services/dialog-provider.service';
import { SessionService } from '@app/core/services/session.service';
import { error } from 'console';
import { MfaInstructionsDialog } from '../mfa-instructions-dialog/mfa-instructions-dialog.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'itfg-mfa-verification',
    templateUrl: './mfa-verification.component.html',
    styleUrl: './mfa-verification.component.scss',
    standalone: false
})
export class MfaVerificationComponent implements OnDestroy {
  data = '';
  errored: boolean = false;
  mfaSecretShown: boolean = false;
  qrCode: string = '';
  secret: string = '';
  _unsubscribe: Subject<void> = new Subject<void>();
  rememberMe: boolean = false;

  constructor(
    private session: SessionService,
    private router: Router,
    private dialogService: DialogProviderService,
  ) {
    const state = this.router.currentNavigation()?.extras?.state;
    const hasQrCode: boolean = state?.hasOwnProperty('qrCode');
    if (hasQrCode) {
      const {secret,qrCode} = this.router.currentNavigation().extras.state;
      this.qrCode = qrCode;
      this.secret = secret;
    }
  }

  submitTotpCode() {
    if (this.data.length !== 6) {
      return;
    }
    this.errored = false;
    this.session.verifyTotpToken(this.data, this.rememberMe).subscribe({
      next: () => {
        this.session.getCurrentlyLoggedOperator();
        this.session.administratorLoaded.pipe(
          takeUntil(this._unsubscribe)
        ).subscribe(() => {
          this.router.navigate([this.session.getLastVisitedRoute()]);
          this.session.checkForPasswordExpiryReminder();
        });
      },
      error: (err) => {
        this.errored = true;
      }
    })
  }

  openTwoFactorSetupInstructions() {
    this.dialogService.open(MfaInstructionsDialog, {
      maxWidth: '700px'
    });
  }

  cancelTwoFactorVerification() {
    this.session.logout();
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}
